import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import {
  METADATA_CATEGORY_TYPE,
  UI_COMPONENT_TYPE,
  UI_CONTAINER_TITLE,
  UI_CONTAINER_TYPE
} from 'app/constants/AnalyticsGa4Constants';
import { selectSeriesInfoForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import SameSeries from './SameSeries';
import SyndeticsUnboundSameSeries from './SyndeticsUnboundSameSeries';

const SameSeriesContainer = () => {
  const dispatch = useDispatch();
  const catalogBib = useSelector(selectCatalogBib);
  const currentLibrary = useSelector(selectCurrentLibrary);
  const series = useSelector(selectSeriesInfoForCurrentBib);

  const trackBibTitleClick = ({ bib, source }) => {
    const bibId = bib.get('metadataId');
    const metadata = {
      metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
      metadata_value: bib.get('title'),
      metadata_enrichment_provider: source
    };
    const ui = {
      ui_container_type: UI_CONTAINER_TYPE.SECTION,
      ui_container_title: UI_CONTAINER_TITLE.IN_THE_SAME_SERIES,
      ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
      ui_component_label: bib.get('title')
    };

    dispatch(trackContentClick({ bibId, metadata, ui }));
  };

  const trackBibImageClick = ({ bib, source }) => {
    const bibId = bib.get('metadataId');
    const metadata = {
      metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
      metadata_value: bib.get('title'),
      metadata_enrichment_provider: source
    };
    const ui = {
      ui_container_type: UI_CONTAINER_TYPE.SECTION,
      ui_container_title: UI_CONTAINER_TITLE.IN_THE_SAME_SERIES,
      ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT
    };

    dispatch(trackContentClick({ bibId, metadata, ui }));
  };

  const hasNovelistSeriesEntries = series.get('seriesEntries').size > 0;
  const isSyndeticsUnboundEnabled = currentLibrary.getIn(['syndeticsUnbound', 'isEnabled']) ?? false;
  const metadataId = catalogBib.get('metadataId');

  if (isSyndeticsUnboundEnabled) {
    return <SyndeticsUnboundSameSeries metadataId={metadataId} />;
  }
  if (hasNovelistSeriesEntries) {
    return (
      <SameSeries
        catalogBib={catalogBib}
        handleBibImage={trackBibImageClick}
        handleBibTitle={trackBibTitleClick}
        series={series}
      />
    );
  }

  return null;
};

export default SameSeriesContainer;
